import React, { useState, useEffect } from 'react'
import { AdjustableBaseErrorData, NonMatchingAdjustableBaseErrors } from '@/config/AdjustableBaseErrors'

import { pushIncompatibleSkus } from '@/utils/analytics'
import styles from './styles.module.scss'

const CartErrors = ({ productSkus }) => {
    const [errorMessages, setErrorMessages] = useState([])

    const checkIncompatibilities = () => {
        const checkMatches = (dataItem) =>
            (dataItem.column1.some((sku) => productSkus.includes(sku)) &&
                dataItem.column2.some((sku) => productSkus.includes(sku))) ||
            (dataItem.column2.some((sku) => productSkus.includes(sku)) &&
                dataItem.column1.some((sku) => productSkus.includes(sku)))

        const newErrorMessages = AdjustableBaseErrorData.filter(checkMatches).map(
            (dataItem) => dataItem.errorMessage
        )

        const nonMatchingErrors = NonMatchingAdjustableBaseErrors.filter(
            (item) =>
                item.column1.some((sku) => productSkus.includes(sku)) &&
                !item.column2.some((sku) => productSkus.includes(sku))
        )

        const nonMatchingErrorMessages = nonMatchingErrors.map(
            (item) => item.errorMessage
        )

        setErrorMessages([...newErrorMessages, ...nonMatchingErrorMessages])
    }

    useEffect(() => {
        checkIncompatibilities()
    }, [productSkus])

    useEffect(() => {
        if (errorMessages.length > 0) {
            pushIncompatibleSkus()
        }
    }, [errorMessages])

    return (
        <div>
            {errorMessages.length > 0 && (
                <div>
                    <ul>
                        {errorMessages.map((message, index) => (
                            <li className={styles.errorMessage} key={index} dangerouslySetInnerHTML={{ __html: message }} />

                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default CartErrors
